import { useSelector } from "react-redux";

export default function useAuthStatus() {
  let auth = useSelector(({ auth = {} }) => auth);
  return [auth.hasAuth, auth.message];
}
